import getSymbolFromCurrencyLib from "currency-symbol-map";
import { countryToCurrency } from "@/utils/country-to-currency";

export const getSymbolByCurrency = (currencyCode: string | null | undefined): string => {
  return getSymbolFromCurrencyLib(currencyCode ?? "USD") ?? "$";
};

export const getSymbolByCountryCode = (countryCode: string | null | undefined): string => {
  const currency = countryCode ? countryToCurrency(countryCode.toUpperCase()) : null;

  return getSymbolByCurrency(currency);
};
